import { gql } from '@apollo/client';

const INVENTORY_UNIT_FIELDS = `
        id
        qrCode
        unitCode
        unitNumber
        toyId
        libraryId
        libraryInventoryId
        status
        source
        currentAssignment {
          orderNumber
          orderStatus
          isReturn
          returnOrderNumber
          returnOrderStatus
        }
        currentOrderItemId
        currentUserId
        currentContents
        currentChecklist
        totalPiecesPresent
        missingContentIds
        qrVersion
        qrImageKey
        qrImageUrl
        qrImageStatus
        qrImageGeneratedAt
        qrImageError
        isQrActive
        qrActivatedAt
        qrActivatedBy
        rackId
        rack {
          name
        }
        shelfLocation
        shelfUpdatedAt
        lastSequenceNo
        createdAt
        updatedAt
`;

const INVENTORY_UNIT_LOG_FIELDS = `
        id
        unitId
        sequenceNo
        toyId
        libraryId
        libraryInventoryId
        orderId
        orderItemId
        returnOrderId
        returnOrderItemId
        customerUserId
        eventType
        fromStatus
        toStatus
        result
        actorId
        actorRole
        channel
        pieceInputs
        checklistInputs
        totalPiecesPresent
        missingContentIds
        pieceDiff
        attachments
        notes
        blockReason
        blockReasonMessage
        metadata
        verifiedBy
        verifiedAt
        overrideBy
        overrideReason
        latitude
        longitude
        actor {
          firstName
          lastName
          userNumber
          contactNo
        }
        createdAt
`;

export const INVENTORY_UNITS_ADMIN = gql`
  query InventoryUnitsAdmin(
    $filter: InventoryUnitFilter!
    $sort: InventoryUnitSort
  ) {
    inventoryUnitsAdmin(filter: $filter, sort: $sort) {
      count
      data {
        ${INVENTORY_UNIT_FIELDS}
      }
    }
  }
`;

export const INVENTORY_UNITS = gql`
  query InventoryUnits(
    $filter: LibrarianInventoryUnitFilter!
    $sort: InventoryUnitSort
  ) {
    inventoryUnits(filter: $filter, sort: $sort) {
      count
      data {
        ${INVENTORY_UNIT_FIELDS}
      }
    }
  }
`;

export const INVENTORY_UNIT_LOGS_ADMIN = gql`
  query InventoryUnitLogsAdmin(
    $filter: InventoryUnitLogAdminFilter!
    $sort: InventoryUnitLogSort
  ) {
    inventoryUnitLogsAdmin(filter: $filter, sort: $sort) {
      count
      data {
        ${INVENTORY_UNIT_LOG_FIELDS}
      }
    }
  }
`;

export const INVENTORY_UNIT_LOGS = gql`
  query InventoryUnitLogs(
    $filter: InventoryUnitLogFilter!
    $sort: InventoryUnitLogSort
  ) {
    inventoryUnitLogs(filter: $filter, sort: $sort) {
      count
      data {
        ${INVENTORY_UNIT_LOG_FIELDS}
      }
    }
  }
`;

export const TRANSFER_TARGET_LIBRARIES = gql`
  query Libraries($filter: LibraryFilter, $sort: LibrarySort) {
    libraries(filter: $filter, sort: $sort) {
      count
      data {
        id
        name
        libraryNumber
      }
    }
  }
`;
